module.exports = __webpack_public_path__ + "img/icon-arrow-right.2b63d89a.svg";